import React, { useMemo, useState } from 'react';
import { const_var, params } from '../../../../redux/reducers/reducer';
import { convertFeet } from '../../../../utils/ConvertFeet';

import LineModel from '../LineModel';
import DimensionValue from '../DimensionValue';
import CenterArrow from '../DoorWIndowsMeasurement/CenterArrow';

const CenterBuildingMeasurement = ({ color }) => {

    const [frontLeftState, setFrontLeftState] = useState(false);
    const [frontRightState, setFrontRightState] = useState(false);
    const [backLeftState, setBackLeftState] = useState(false);
    const [backRightState, setBackRightState] = useState(false);

     ///////////// front //////////////
     const frontPosState = useMemo(() => {
        let offset = false;

        if (params.leanF_p_w < 10) {
            if ((params.leanF_p_pos - params.leanF_p_d / 2 - 2.5 < 0.8 && params.leanF_p_pos - params.leanF_p_d / 2 - 2.5 > -1.8) ||
                (params.leanF_p_pos + params.leanF_p_d / 2 + 2.5 > -0.8 && params.leanF_p_pos + params.leanF_p_d / 2 + 2.5 < 1.8)) {
                offset = true;
            }
        }
        
        if (params.add_storage_check_front && params.leanF_p_w < 12) {
            if (params.leanF_p_pos - params.leanF_p_d / 2 + parseInt(params.add_storage_front) + params.frontLeanStoragePosition + 1.5 > -0.8 && params.leanF_p_pos - params.leanF_p_d / 2 + parseInt(params.add_storage_front) + params.frontLeanStoragePosition + 1.5 < 1.8) {
                offset = true;
            }
        }

        return offset;
        
    }, [params.leanF_p_d, params.p_w, params.leanF_p_w, params.leanF_p_pos, params.add_storage_check_front, params.add_storage_front, params.frontLeanStoragePosition])

    ///////////// back //////////////
    const backPosState = useMemo(() => {
        let offset = false;

        if (params.leanB_p_w < 10) {
            if ((params.leanB_p_pos - params.leanB_p_d / 2 - 2.5 < 0.7 && params.leanB_p_pos - params.leanB_p_d / 2 - 2.5 > -1.6) ||
                (params.leanB_p_pos + params.leanB_p_d / 2 + 2.5 > -0.7 && params.leanB_p_pos + params.leanB_p_d / 2 + 2.5 < 1.6)) {
                offset = true;
            }
        }

        if (params.add_storage_check_back && params.leanB_p_w < 12) {
            if (params.leanB_p_pos - params.leanB_p_d / 2 + parseInt(params.add_storage_back) + params.backLeanStoragePosition + 1.5 > -0.7 && params.leanB_p_pos - params.leanB_p_d / 2 + parseInt(params.add_storage_back) + params.backLeanStoragePosition + 1.5 < 1.6) {
                offset = true;
            }
        } 

        return offset;
        
    }, [params.leanB_p_d, params.p_w, params.leanB_p_w, params.leanB_p_pos, params.add_storage_check_back, params.add_storage_back, params.backLeanStoragePosition])
   
    ///////////// left //////////////
    const leftPosState = useMemo(() => {
        let offset = false;
        
        if (params.lean_p_w < 10) {
            if ((params.lean_p_pos + params.left + params.lean_p_d / 2 + 2.5 > -0.6 && params.lean_p_pos + params.lean_p_d / 2 + 2.5 < 1.6) ||
                (params.lean_p_pos - params.lean_p_d / 2 - 2.5 < 0.6 && params.lean_p_pos - params.lean_p_d / 2 - 2.5 > -1.6)) {
                offset = true;
            }
        }

        if (params.add_storage_check && params.lean_p_w < 12) {
            if (params.lean_p_pos - params.lean_p_d / 2 + parseInt(params.add_storage) + params.leftLeanStoragePosition + 1.5 > -0.6 && params.lean_p_pos - params.lean_p_d / 2 + parseInt(params.add_storage) + params.leftLeanStoragePosition + 1.5 < 1.6) {
                offset = true;
            }
        }

        return offset;
        
    }, [params.lean_p_d, params.p_d, params.lean_p_w, params.lean_p_pos, params.add_storage_check, params.add_storage, params.leftLeanStoragePosition ])

    ///////////// right //////////////
    const rightPosState = useMemo(() => {
        let offset = false;
        
        if (params.leanR_p_w < 10) {
            if ((params.leanR_p_pos + params.leanR_p_d / 2 + 2.5 > -0.8 && params.leanR_p_pos + params.leanR_p_d / 2 + 2.5 < 1.6) ||
                (params.leanR_p_pos - params.leanR_p_d / 2 - 2.5 < 0.8 && params.leanR_p_pos - params.leanR_p_d / 2 - 2.5 > -1.6)) {
                offset = true;
            }
        }

        if (params.add_storage_check_right && params.leanR_p_w < 12) {
            if (params.leanR_p_pos - params.leanR_p_d / 2 + parseInt(params.add_storage_right) + params.rightLeanStoragePosition + 1.5 > -0.8 && params.leanR_p_pos - params.leanR_p_d / 2 + parseInt(params.add_storage_right) + params.rightLeanStoragePosition + 1.5 < 1.6) {
                offset = true;
            }
        }

        return offset;
        
    }, [params.leanR_p_d, params.p_d, params.leanR_p_w, params.leanR_p_pos, params.add_storage_check_right, params.add_storage_right, params.rightLeanStoragePosition])

    
    const leftHeight = params.singleSlope 
        ? params.p_h - (params.p_r_p / 12) * params.p_w 
        : params.p_h;
    let showHeightInInch = true;
    if(const_var.c_m_a[params.p_b_t]!=undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width!=undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length>0){
        showHeightInInch = false
    }
    const groups = [
        // Width
        {
            position: [0, 0, params.p_d / 2 + 0.3],
            lineModelProps: { length: params.p_w + 0.4, position: [0, 0.2, 0], rotation: [0, 0, Math.PI / 2], color },
            dimensionValueProps: { position: [0, frontPosState ? 1.5 : 0, frontPosState ? 0 : 0.4], rotation: [0, 0, 0], value: `${convertFeet(params.p_w)}W`, slopeAngle: (frontPosState ? 0 : 25), type: 'cb', dir: 'front', cmpPos: [0, 0, params.p_d / 2 + 0.3] },
        },
        {
            position: [0, 0, -params.p_d / 2 - 0.3],
            lineModelProps: { length: params.p_w + 0.4, position: [0, 0.2, 0], rotation: [0, 0, Math.PI / 2], color },
            dimensionValueProps: { position: [0, backPosState ? 1.5 : 0, backPosState ? 0 : -0.4], rotation: [0, Math.PI, 0], value: `${convertFeet(params.p_w)}W`, slopeAngle: (backPosState ? 0 : 25), type: 'cb', dir: 'back', cmpPos: [0, 0, -params.p_d / 2 - 0.3] },
        },
        // Length
        {
            position: [params.p_w / 2 + 0.2, 0, 0],
            lineModelProps: { length: params.p_d + 0.6, position: [0, 0.2, 0], rotation: [Math.PI / 2, 0, 0], color },
            dimensionValueProps: { position: [rightPosState ? 0.1 : 0.3, rightPosState ? 1.5 : 0, 0], rotation: [0, Math.PI / 2, 0], value: `${convertFeet(params.p_d)}L`, slopeAngle: (rightPosState ? 0 : 25), type: 'cb', dir: 'right', cmpPos: [params.p_w / 2 + 0.2, 0, 0] },
        },
        {
            position: [-params.p_w / 2 - 0.2, 0, 0],
            lineModelProps: { length: params.p_d + 0.6, position: [0, 0.2, 0], rotation: [Math.PI / 2, 0, 0], color },
            dimensionValueProps: { position: [leftPosState ? -0.1 : -0.3, leftPosState ? 1.5 : 0, 0], rotation: [0, -Math.PI / 2, 0], value: `${convertFeet(params.p_d)}L`, slopeAngle: (leftPosState ? 0 : 25), type: 'cb', dir: 'left', cmpPos: [-params.p_w / 2 - 0.2, 0, 0] },
        },
        // Height
        {
            position: [-params.p_w / 2 - 0.2, 0, params.p_d / 2 + 0.3],
            lineModelProps: { length: leftHeight + (params.p_r_s === 1 && 0.2) - 0.4, position: [0, (leftHeight + (params.p_r_s === 1 && 0.2)) / 2, 0], rotation: [0, 0, 0], color },
            dimensionValueProps: { position: [-[...`${convertFeet(leftHeight)}H`].length * 0.2, frontLeftState ? 3 * leftHeight / 4: leftHeight / 2, -0.2], rotation: [0, 0, 0], value: `${convertFeet(leftHeight,showHeightInInch)}H`, slopeAngle: 0, type: 'cb', dir: 'front-left', cmpPos: [-params.p_w / 2 - 0.2, 0, params.p_d / 2 + 0.3] },
            checkBackSide: true,
        },
        {
            position: [params.p_w / 2 + 0.2, 0, params.p_d / 2 + 0.3],
            rotation: [0, -Math.PI / 2, 0],
            lineModelProps: { length: leftHeight + (params.p_r_s === 1 && 0.2) - 0.4, position: [0, (leftHeight + (params.p_r_s === 1 && 0.2)) / 2, 0], rotation: [0, 0, 0], color },
            dimensionValueProps: { position: [[...`${convertFeet(leftHeight)}H`].length * 0.2, frontRightState ? 3 * leftHeight / 4: leftHeight / 2, -0.2], rotation: [0, 0, 0], value: `${convertFeet(leftHeight,showHeightInInch)}H`, slopeAngle: 0, type: 'cb', dir: 'front-right', cmpPos: [params.p_w / 2 + 0.2, 0, params.p_d / 2 + 0.3] },
            checkBackSide: true,
            visible: params.singleSlope ? false : true,
        },
        {
            position: [-params.p_w / 2 - 0.2, 0, -params.p_d / 2 - 0.3],
            rotation: [0, -Math.PI / 2, 0],
            lineModelProps: { length: leftHeight + (params.p_r_s === 1 && 0.2) - 0.4, position: [0, (leftHeight + (params.p_r_s === 1 && 0.2)) / 2, 0], rotation: [0, 0, 0], color },
            dimensionValueProps: { position: [-[...`${convertFeet(leftHeight)}H`].length * 0.2, backRightState ? 3 * leftHeight / 4: leftHeight / 2, 0.2], rotation: [0, Math.PI, 0], value: `${convertFeet(leftHeight,showHeightInInch)}H`, slopeAngle: 0, type: 'cb', dir: 'left-back', cmpPos: [-params.p_w / 2 - 0.2, 0, -params.p_d / 2 - 0.3] },
            checkBackSide: true,
        },
        {
            position: [params.p_w / 2 + 0.2, 0, -params.p_d / 2 - 0.3],
            lineModelProps: { length: leftHeight + (params.p_r_s === 1 && 0.2) - 0.4, position: [0, (leftHeight + (params.p_r_s === 1 && 0.2)) / 2, 0], rotation: [0, 0, 0], color },
            dimensionValueProps: { position: [[...`${convertFeet(leftHeight)}H`].length * 0.2, backLeftState ? 3 * leftHeight / 4: leftHeight / 2, 0.2], rotation: [0, Math.PI, 0], value: `${convertFeet(leftHeight,showHeightInInch)}H`, slopeAngle: 0, type: 'cb', dir: 'right-back', cmpPos: [params.p_w / 2 + 0.2, 0, -params.p_d / 2 - 0.3] },
            checkBackSide: true,
            visible: params.singleSlope ? false : true,
        },
    ];


    useMemo(() => {
        const checkAndSetState = (addLean, lean_p_h, b_l_t_r_p, lean_p_w, setFunction) => {
            if (addLean && (lean_p_h + b_l_t_r_p * lean_p_w / 12 > leftHeight / 2) && (lean_p_h + b_l_t_r_p * lean_p_w / 12 <= leftHeight / 2 + 1)) {
                setFunction(true);
            } else {
                setFunction(false);
            }
        }
    
        checkAndSetState(params.add_left_lean, params.lean_p_h, params.b_l_t_r_p, params.lean_p_w, setFrontLeftState);
        checkAndSetState(params.add_front_lean, params.leanF_p_h, params.b_l_t_r_pF, params.leanF_p_w, setFrontRightState);
        checkAndSetState(params.add_right_lean, params.leanR_p_h, params.b_l_t_r_pR, params.leanR_p_w, setBackLeftState);
        checkAndSetState(params.add_back_lean, params.leanB_p_h, params.b_l_t_r_pB, params.leanB_p_w, setBackRightState);
    }, [params.add_left_lean, params.lean_p_h, params.b_l_t_r_p, params.lean_p_w, params.add_front_lean, params.leanF_p_h, params.b_l_t_r_pF, params.leanF_p_w, params.add_right_lean, params.leanR_p_h, params.b_l_t_r_pR, params.leanR_p_w, params.add_back_lean, params.leanB_p_h, params.b_l_t_r_pB, params.leanB_p_w, leftHeight]);

    return (
        <group name='Measurements-main'>
            {groups.map((group, index) => (
                <group key={index} position={group.position} rotation={group.rotation} visible={group.visible === false ? false : true}>
                    <LineModel {...group.lineModelProps} />
                    <DimensionValue {...group.dimensionValueProps}  checkBackSide={group.checkBackSide} />
                </group>
            ))}
            <CenterArrow />
        </group>
    );
};

export default CenterBuildingMeasurement;
